import { useState, useMemo } from 'react';
import ShopLayout from '../components/ShopLayout';
import DealCard from '../components/DealCard';
import { PHONES, PHONE_BRANDS } from '../data/phones';

export default function PhonesPage() {
  const [search, setSearch] = useState('');
  const [brand, setBrand] = useState('All');

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return PHONES.filter(p => {
      const matchBrand = brand === 'All' || p.brand === brand;
      const matchSearch = !q || p.name.toLowerCase().includes(q) || p.package?.toLowerCase().includes(q);
      return matchBrand && matchSearch;
    });
  }, [search, brand]);

  return (
    <ShopLayout
      title="Smartphones"
      subtitle="The latest devices on Vodacom's network. Explore contract and prepaid options."
      search={search}
      onSearch={setSearch}
      filters={PHONE_BRANDS}
      activeFilter={brand}
      onFilter={setBrand}
    >
      {filtered.length === 0
        ? <p className="shop-empty">No deals match your search.</p>
        : filtered.map(p => <DealCard key={p.id} deal={p} type="phones" />)
      }
    </ShopLayout>
  );
}
